import React from 'react'

export default function PaymentSuccessIcon() {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 375 280"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Admin"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="Group-3" transform="translate(6.000000, 5.000000)">
          <path
            d="M15.4969526,248.8 C11.6625188,232.051237 17.8806264,214.027176 34.1512752,194.727816 C58.5572479,165.778776 66.1399394,159.188944 55.0611932,129.620033 C43.9824469,100.051122 17.9707551,37.9751361 73.606412,10.4542885 C129.242068,-17.0665592 157.916122,17.4115398 187.136878,26.5875262 C216.357634,35.7635126 299.539546,58.2507236 331.578018,108.977026 C363.616494,159.70333 337.393711,159.041614 331.578018,197.465317 C325.76233,235.889018 344.887459,248.8 321.33178,248.8 C305.627996,248.8 203.683053,248.8 15.4969526,248.8 Z"
            id="Path-2"
            fill="#DFF1F1"
            fillRule="nonzero"
          />
          <rect
            id="Rectangle"
            fill="#B2CECE"
            fillRule="nonzero"
            x="0"
            y="242.4"
            width="362.4"
            height="6.4"
            rx="3.2"
          />
          <rect
            id="Rectangle"
            stroke="#252B4C"
            strokeWidth="0.8"
            fill="#FFFFFF"
            fillRule="nonzero"
            x="76.8"
            y="98.4"
            width="215.677571"
            height="131.018868"
            rx="11.2"
          />
          <path
            d="M63.6004934,229.418868 L305.999514,229.418868 C307.988007,229.418868 309.6,231.031126 309.6,233.019949 C309.6,233.943874 309.244936,234.832454 308.608254,235.501886 C304.914042,239.386118 299.788635,241.584906 294.428649,241.584906 L75.1713578,241.584906 C69.8113712,241.584906 64.6859645,239.386118 60.9917538,235.501886 C59.6212439,234.060882 59.6781986,231.781514 61.1189657,230.410778 C61.7882872,229.77399 62.6767205,229.418868 63.6004934,229.418868 Z"
            id="Rectangle-Copy"
            stroke="#252B4C"
            strokeWidth="0.8"
            fill="#FFFFFF"
            fillRule="nonzero"
          />
          <rect
            id="Rectangle-Copy-2"
            stroke="#252B4C"
            strokeWidth="0.8"
            x="81.8736136"
            y="103.079246"
            width="206.320627"
            height="121.660378"
            rx="8"
          />
          <path
            d="M235.795351,175.879246 L268.544657,175.879246 C273.195585,175.879246 276.965907,179.65019 276.965907,184.301886 L276.965907,261.509434 C276.965907,266.419558 272.986122,270.4 268.07681,270.4 L236.263198,270.4 C231.353886,270.4 227.374101,266.419558 227.374101,261.509434 L227.374101,184.301886 C227.374101,179.65019 231.144423,175.879246 235.795351,175.879246 Z"
            id="Rectangle"
            stroke="#252B4C"
            strokeWidth="0.8"
            fill="#FFFFFF"
            fillRule="nonzero"
          />
          <path
            d="M251.99989,229.600006 C251.52821,229.601234 251.075626,229.413772 250.742969,229.07937 L249.819137,228.155529 C249.700035,228.035365 249.51996,227.999434 249.363862,228.064686 L248.156878,228.56459 C247.249839,228.940036 246.210158,228.509367 245.834283,227.602499 L245.334383,226.395502 C245.270057,226.238966 245.117406,226.136918 244.94817,226.137316 L243.640249,226.137316 C242.659026,226.136145 241.863881,225.34099 241.86271,224.359758 L241.86271,223.052886 C241.863125,222.883928 241.7613,222.731503 241.605057,222.6672 L240.39701,222.166233 C239.490152,221.790354 239.059488,220.750662 239.434929,219.843614 L239.934829,218.636086 C239.999627,218.479942 239.963748,218.300125 239.843986,218.180806 L238.920686,217.256965 C238.226438,216.562601 238.226438,215.43693 238.920686,214.742566 L239.844518,213.818724 C239.96468,213.699621 240.000611,213.519544 239.93536,213.363444 L239.43546,212.156447 C239.060019,211.2494 239.490683,210.209708 240.397542,209.833829 L241.604526,209.333393 C241.760977,209.269256 241.863037,209.116794 241.86271,208.947706 L241.86271,207.640303 C241.863881,206.659071 242.659026,205.863917 243.640249,205.862746 L244.947107,205.862746 C245.116064,205.863161 245.268487,205.761334 245.33279,205.60509 L245.833752,204.397031 C246.209626,203.490163 247.249308,203.059494 248.156346,203.43494 L249.36333,203.934845 C249.519459,203.999794 249.69936,203.963898 249.818606,203.844001 L250.742969,202.920691 C251.437326,202.226436 252.562986,202.226436 253.257342,202.920691 L254.181174,203.844533 C254.300348,203.964562 254.480336,204.000476 254.63645,203.935376 L255.843965,203.435471 C256.751003,203.060026 257.790684,203.490694 258.166559,204.397562 L258.66699,205.604559 C258.731126,205.761012 258.883586,205.863073 259.052673,205.862746 L260.35953,205.862746 C261.340753,205.863917 262.135899,206.659071 262.13707,207.640303 L262.13707,208.947175 C262.136655,209.116134 262.23848,209.268558 262.394723,209.332862 L263.60277,209.833829 C264.509628,210.209708 264.940292,211.2494 264.564851,212.156447 L264.064951,213.363444 C263.999807,213.519291 264.03551,213.699066 264.155262,213.818193 L265.079094,214.742566 C265.412617,215.075945 265.6,215.528192 265.6,215.999765 C265.6,216.471338 265.412617,216.923586 265.079094,217.256965 L264.155262,218.180806 C264.035501,218.300125 263.999622,218.479942 264.06442,218.636086 L264.564319,219.843614 C264.939761,220.750662 264.509097,221.790354 263.602238,222.166233 L262.395254,222.666669 C262.238803,222.730806 262.136743,222.883266 262.13707,223.052355 L262.13707,224.359227 C262.135899,225.340459 261.340753,226.135614 260.35953,226.136785 L259.052673,226.136785 C258.883437,226.136386 258.730786,226.238435 258.666459,226.394971 L258.166559,227.602499 C257.790684,228.509367 256.751003,228.940036 255.843965,228.56459 L254.63645,228.064686 C254.480336,227.999585 254.300348,228.035499 254.181174,228.155529 L253.256811,229.07937 C252.924154,229.413772 252.47157,229.601234 251.99989,229.600006 Z"
            id="Combined-Shape"
            fill="#00B8A4"
            fillRule="nonzero"
          />
          <path
            d="M247.725718,215.878455 L249.190989,217.722207 C249.460522,218.06136 249.951044,218.124349 250.297521,217.864298 L256.044377,213.550958 L256.044377,213.550958"
            id="Path-3"
            stroke="#FFFFFF"
            strokeWidth="2.4"
            strokeLinecap="round"
          />
          <rect
            id="Rectangle-Copy-4"
            stroke="#252B4C"
            strokeWidth="0.8"
            fill="#FFFFFF"
            fillRule="nonzero"
            x="248.427226"
            y="258.701886"
            width="7.48555563"
            height="7.48679246"
            rx="3.74277782"
          />
          <path
            d="M237.737351,179.981361 L266.602657,179.981361 C270.119246,179.981361 272.970004,182.942254 272.970004,186.594698 L272.970004,250.082738 C272.970004,251.543716 271.829701,252.728073 270.423066,252.728073 L252.170004,252.728073 L233.916943,252.728073 C232.510308,252.728073 231.370004,251.543716 231.370004,250.082738 L231.370004,186.594698 C231.370004,182.942254 234.220762,179.981361 237.737351,179.981361 Z"
            id="Rectangle-Copy-3"
            stroke="#252B4C"
            strokeWidth="0.8"
          />
          <circle
            id="Oval-Copy-2"
            fill="#252B4C"
            fillRule="nonzero"
            cx="146.4"
            cy="176"
            r="1.6"
          />
          <circle
            id="Oval-Copy-3"
            fill="#252B4C"
            fillRule="nonzero"
            cx="183.2"
            cy="201.6"
            r="1.6"
          />
          <circle
            id="Oval-Copy"
            fill="#252B4C"
            fillRule="nonzero"
            cx="214.4"
            cy="135.2"
            r="1.6"
          />
          <path
            d="M184.799774,192.000012 C183.828668,192.002542 182.896878,191.616589 182.211994,190.928115 L180.309988,189.02609 C180.064778,188.778693 179.694035,188.704717 179.372657,188.839058 L176.88769,189.868274 C175.020258,190.64125 172.879737,189.754579 172.105877,187.887498 L171.076671,185.402506 C170.944234,185.080225 170.629953,184.870126 170.281526,184.870944 L167.588748,184.870944 C165.568585,184.868534 163.931519,183.231451 163.929109,181.211266 L163.929109,178.520649 C163.929963,178.172793 163.720323,177.858978 163.398646,177.726589 L160.911492,176.695185 C159.04443,175.921317 158.157769,173.780774 158.930736,171.913323 L159.959942,169.427236 C160.09335,169.105762 160.019482,168.73555 159.772913,168.489895 L157.872,166.587869 C156.442666,165.158295 156.442666,162.840738 157.872,161.411164 L159.774006,159.509138 C160.0214,159.263926 160.095376,158.893178 159.961035,158.571797 L158.93183,156.086803 C158.158862,154.219353 159.045524,152.07881 160.912586,151.304942 L163.397553,150.274632 C163.719658,150.142586 163.929782,149.828695 163.929109,149.480571 L163.929109,146.78886 C163.931519,144.768675 165.568585,143.131593 167.588748,143.129182 L170.279338,143.129182 C170.627191,143.130037 170.941002,142.920395 171.07339,142.598715 L172.104783,140.111534 C172.878643,138.244454 175.019164,137.357783 176.886595,138.130758 L179.371563,139.159974 C179.693004,139.293694 180.063389,139.219789 180.308894,138.972943 L182.211994,137.072011 C183.641554,135.642663 185.959087,135.642663 187.388646,137.072011 L189.290652,138.974038 C189.53601,139.221158 189.906574,139.295098 190.227984,139.161068 L192.714045,138.131852 C194.581477,137.358877 196.721998,138.245547 197.495858,140.112628 L198.526157,142.597622 C198.658202,142.91973 198.972089,143.129855 199.320209,143.129182 L202.010798,143.129182 C204.030962,143.131593 205.668028,144.768675 205.670438,146.78886 L205.670438,149.479478 C205.669584,149.827334 205.879224,150.141149 206.2009,150.273538 L208.688055,151.304942 C210.555117,152.07881 211.441778,154.219353 210.66881,156.086803 L209.639606,158.571797 C209.505485,158.892658 209.57899,159.262784 209.82554,159.508044 L211.727546,161.411164 C212.41421,162.097533 212.8,163.02863 212.8,163.999517 C212.8,164.970402 212.41421,165.9015 211.727546,166.587869 L209.82554,168.489895 C209.578971,168.73555 209.505103,169.105762 209.638511,169.427236 L210.667717,171.913323 C211.440684,173.780774 210.554023,175.921317 208.686962,176.695185 L206.201994,177.725495 C205.879888,177.857542 205.669766,178.171431 205.670438,178.519555 L205.670438,181.210173 C205.668028,183.230358 204.030962,184.86744 202.010798,184.86985 L199.320209,184.86985 C198.971781,184.869031 198.6575,185.07913 198.525063,185.401411 L197.495858,187.887498 C196.721998,189.754579 194.581477,190.64125 192.714045,189.868274 L190.227984,188.839058 C189.906574,188.705028 189.53601,188.778969 189.290652,189.02609 L187.387552,190.928115 C186.702668,191.616589 185.770878,192.002542 184.799774,192.000012 Z"
            id="Combined-Shape"
            fill="#00B8A4"
            fillRule="nonzero"
          />
          <path
            d="M176,163.749766 L179.529374,168.190782 C179.798906,168.529935 180.289429,168.592924 180.635906,168.332874 L193.126654,158.957861 L193.126654,158.957861"
            id="Path-3"
            stroke="#FFFFFF"
            strokeWidth="5.6"
            strokeLinecap="round"
          />
          <polygon
            id="Path-4"
            fill="#00B8A4"
            fillRule="nonzero"
            points="157.830675 124.4 157.830675 131.02656 164.222818 127.608375"
          />
          <polygon
            id="Path-4-Copy"
            fill="#00B8A4"
            fillRule="nonzero"
            transform="translate(219.426747, 161.717209) rotate(90.000000) translate(-219.426747, -161.717209) "
            points="217.426747 159.643864 217.426747 163.790554 221.426747 161.651563"
          />
          <polygon
            id="Path-4-Copy-2"
            fill="#00B8A4"
            fillRule="nonzero"
            transform="translate(160.226747, 189.717209) rotate(90.000000) translate(-160.226747, -189.717209) "
            points="158.226747 187.643864 158.226747 191.790554 162.226747 189.651563"
          />
          <rect
            id="Rectangle"
            fill="#252B4C"
            fillRule="nonzero"
            transform="translate(215.600000, 182.000000) rotate(-15.000000) translate(-215.600000, -182.000000) "
            x="213.6"
            y="180"
            width="4"
            height="4"
          />
          <path
            d="M82.732528,196.950062 L120.427775,190.888978 C124.353798,190.257707 127.02472,186.56329 126.393449,182.637267 C126.383984,182.578406 126.373789,182.519665 126.362866,182.461056 L119.818119,147.346305 C119.424829,145.236173 117.43615,143.812612 115.31189,144.120602 L104.681669,145.661841 L104.681669,145.661841 L81.8736136,176 L82.732528,196.950062 Z"
            id="Path-2"
            fill="#DFF1F1"
            fillRule="nonzero"
          />
          <rect
            id="Rectangle-Copy"
            fill="#252B4C"
            fillRule="nonzero"
            transform="translate(151.082842, 152.710102) rotate(-15.000000) translate(-151.082842, -152.710102) "
            x="149.482842"
            y="151.110102"
            width="3.2"
            height="3.2"
          />
          <rect
            id="Rectangle"
            fill="#00B8A4"
            fillRule="nonzero"
            transform="translate(82.732528, 169.776426) rotate(-8.000000) translate(-82.732528, -169.776426) "
            x="48.3325281"
            y="148.976426"
            width="68.8"
            height="41.6"
            rx="2.4"
          />
          <rect
            id="Rectangle"
            fill="#252B4C"
            fillRule="nonzero"
            transform="translate(81.619143, 161.854281) rotate(-8.000000) translate(-81.619143, -161.854281) "
            x="47.2191433"
            y="157.854281"
            width="68.8"
            height="8"
          />
          <rect
            id="Rectangle"
            fill="#FFFFFF"
            fillRule="nonzero"
            transform="translate(105.055850, 179.160950) rotate(-8.000000) translate(-105.055850, -179.160950) "
            x="97.0558504"
            y="175.56095"
            width="16"
            height="7.2"
            rx="0.8"
          />
          <circle
            id="Oval-Copy-2"
            fill="#00B8A4"
            fillRule="nonzero"
            cx="45.1905227"
            cy="217.375634"
            r="4.61319797"
          />
          <circle
            id="Oval-Copy"
            fill="#252B4C"
            fillRule="nonzero"
            cx="273.251437"
            cy="81.3390864"
            r="4.61319797"
          />
          <polygon
            id="Path-4"
            fill="#00B8A4"
            fillRule="nonzero"
            points="116.548002 43 116.548002 62.1060206 134.97814 52.2505446"
          />
          <polygon
            id="Path-4-Copy"
            fill="#00B8A4"
            fillRule="nonzero"
            transform="translate(314.144797, 129.794794) rotate(90.000000) translate(-314.144797, -129.794794) "
            points="308.378299 123.816823 308.378299 135.772764 319.911294 129.60552"
          />
          <rect
            id="Rectangle"
            fill="#252B4C"
            fillRule="nonzero"
            transform="translate(311.911335, 182.675127) rotate(-15.000000) translate(-311.911335, -182.675127) "
            x="306.144838"
            y="176.90863"
            width="11.532995"
            height="11.532995"
          />
          <rect
            id="Rectangle-Copy"
            fill="#252B4C"
            fillRule="nonzero"
            transform="translate(61.092323, 120.625066) rotate(-15.000000) translate(-61.092323, -120.625066) "
            x="56.4791252"
            y="116.011868"
            width="9.22639592"
            height="9.22639592"
          />
        </g>
      </g>
    </svg>
  )
}
